(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ink-200-ugc-gallery"] && !Shopify.designMode) return;
  try {
    const loadInk200Captions = async (video) => {
    const track = video.querySelector('track[data-src]');
    if (!track || track.dataset.captionState) return;

    track.dataset.captionState = 'loading';

    try {
      const response = await fetch(track.dataset.src);
      if (!response.ok) throw new Error('Caption request failed');

      const captionText = await response.text();
      track.src = URL.createObjectURL(new Blob([captionText], { type: 'text/vtt' }));
      track.track.mode = 'showing';
      track.dataset.captionState = 'ready';
    } catch (error) {
      track.dataset.captionState = 'error';
    }
  };

  const initializeInk200ExclusivePlayback = (scope = document) => {
    scope.querySelectorAll('.ink-200-ugc').forEach((gallery) => {
      if (gallery.dataset.exclusivePlaybackReady === 'true') return;

      gallery.dataset.exclusivePlaybackReady = 'true';
      gallery.addEventListener(
        'play',
        (event) => {
          if (!(event.target instanceof HTMLVideoElement)) return;

          loadInk200Captions(event.target);

          gallery.querySelectorAll('video').forEach((video) => {
            if (video !== event.target && !video.paused) video.pause();
          });
        },
        true
      );
    });
  };

  initializeInk200ExclusivePlayback();
  document.addEventListener('shopify:section:load', (event) => {
    initializeInk200ExclusivePlayback(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ink-roll-cart-notes"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('ink-roll-cart-notes')) return;
  const states = new Map();
  let queue = Promise.resolve(), sequence = 0, resuming = false, checkoutPending = false;
  const checkoutSelector = 'button[name="checkout"],input[name="checkout"],a[href*="/checkout"]';
  const allowed = {'Roll core diameter':['1 inch','2 inch','3 inch'],'Unwind direction':['Bottom','Top','Right','Left']};
  const isTarget = item => item?.handle === '1000-2-gloss-custom-vinyl-roll-labels' && item.properties?.['_Roll configuration'] === 'cart_notes';
  class RollCartNotes extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.fields = [...this.querySelectorAll('[data-roll-field]')];
      this.status = this.querySelector('[data-roll-status]');
      this.saveButton = this.querySelector('[data-roll-save]');
      let state = states.get(this.dataset.lineKey);
      if (!state) {
        state = {key:this.dataset.lineKey,fields:{},dirty:false,pending:null,artwork:null,uploading:false,editing:false,saved:this.dataset.artworkSaved === 'true',fileName:this.dataset.artworkName || '',panels:new Set(),root:null,instance:null,signature:''};
        states.set(state.key,state);
      }
      this.state = state;state.panels.add(this);
      this.fields.forEach(field => { if (field.dataset.rollField in state.fields) field.value = state.fields[field.dataset.rollField]; });
      const help = this.querySelector('[data-roll-unwind-help]');
      if (help) {help.id='InkRollUnwindHelp-'+(++sequence);this.querySelector('[data-roll-field="Unwind direction"]').setAttribute('aria-describedby',help.id);}
      if (!this.bound) {
        this.bound = true;
        const change = event => {
          if (!event.target.matches('[data-roll-field]')) return;
          state.fields[event.target.dataset.rollField] = event.target.value;state.dirty = true;
          this.message(this.dataset.unsaved);
        };
        this.addEventListener('input',change);this.addEventListener('change',change);
        this.saveButton?.addEventListener('click',()=>this.save().catch(()=>{}));
        this.querySelector('[data-roll-save-artwork]')?.addEventListener('click',()=>this.save().catch(()=>{}));
        this.querySelector('[data-roll-replace-artwork]')?.addEventListener('click',()=>{this.querySelector('[data-roll-upload-host]').hidden=false;this.querySelector('[data-upload-input]')?.click();});
        this.addEventListener('ink:roll-artwork:change',event=>this.artworkChanged(event.detail.instance));
      }
      const newRoot = this.querySelector('[data-ink-roll-cart-artwork]');
      if (newRoot) {
        if (state.root && state.root !== newRoot) newRoot.replaceWith(state.root);
        else state.root = newRoot;
        const initialize = () => {
          if (!this.isConnected || !window.InkRollCartArtwork || state.instance) return;
          state.instance = new window.InkRollCartArtwork(state.root);
          state.root._inkRollCartArtworkInstance = state.instance;
        };
        initialize();
        if (!state.instance) document.addEventListener('ink:roll-cart-artwork-ready',initialize,{once:true});
      }
      this.refresh();
    }
    disconnectedCallback() {this.connected=false;this.state?.panels.delete(this);}
    refresh() {
      const s=this.state;
      const summary=this.querySelector('[data-roll-artwork-saved]');
      if(summary){summary.hidden=!s.saved;summary.querySelector('[data-roll-artwork-name]').textContent=s.fileName;}
      const reminder=this.querySelector('[data-roll-artwork-required]');if(reminder)reminder.hidden=s.saved;
      const host=this.querySelector('[data-roll-upload-host]');if(host)host.hidden=s.saved&&!s.artwork&&!s.uploading&&!s.editing;
      if(this.saveButton)this.saveButton.disabled=!!s.pending;
      const retry=this.querySelector('[data-roll-save-artwork]');if(retry)retry.hidden=!s.artwork||!!s.pending||s.uploading;
      this.fields.forEach(f=>{f.disabled=!!s.pending;});
      if(s.dirty)this.querySelector('details')?.setAttribute('open','');
    }
    message(text,error=false){this.status.textContent=text;this.status.toggleAttribute('data-error',error);}
    notify(text,error=false){this.state.panels.forEach(panel=>{panel.refresh();if(text)panel.message(text,error);});}
    artworkChanged(instance) {
      const s=this.state;
      s.editing=!instance.editor.hidden;s.uploading=instance.cloudUploadState==='uploading';
      if(instance.cloudUploadState==='ready'&&instance.hasValidFile()){
        const signature=instance.cloudUploadIdInput.value+':'+instance.cloudVersionIdInput.value;
        if(signature!==s.signature){
          s.signature=signature;
          s.artwork={'Artwork ID':instance.cloudUploadIdInput.value,'_Artwork version':instance.cloudVersionIdInput.value,'_Artwork GCS object':instance.cloudArtworkKeyInput.value,'_Artwork shape GCS object':instance.cloudShapeKeyInput.value,'Shape':instance.shapePropertyInput.value,'Artwork file':instance.acceptedFile.name};
          this.save().catch(()=>{});
        }
      } else if(instance.cloudUploadState==='idle'||instance.cloudUploadState==='error') {
        if(!s.pending)s.artwork=null;
      }
      this.notify(instance.cloudUploadState==='error'?this.dataset.uploadFailed:'',instance.cloudUploadState==='error');
    }
    async request(url,options={}){
      const response=await fetch(url,{credentials:'same-origin',...options});
      if(!response.ok)throw new Error(this.dataset.failed);
      return response.json();
    }
    save(){
      const s=this.state;
      if(s.pending)return s.pending;
      if(!s.dirty&&!s.artwork)return Promise.resolve();
      const fields={...s.fields},artwork=s.artwork?{...s.artwork}:null;let completed=false;
      s.pending=queue.catch(()=>{}).then(async()=>{
        const helper=window.Alpine?.store?.('xCartHelper');
        await helper?.waitForCartUpdate?.();window.updatingCart=true;
        try{
          const root=(this.dataset.cartRoot||'/cart').replace(/\/$/,'');
          const cart=await this.request(root+'.js');
          const item=cart.items.find(line=>line.key===s.key);
          if(!isTarget(item)||String(item.variant_id)!==this.dataset.variantId)throw new Error(this.dataset.stale);
          const properties={...item.properties};
          for(const[key,value]of Object.entries(fields)){
            if(key==='Roll label notes'){const note=value.trim().slice(0,500);if(note)properties[key]=note;else delete properties[key];}
            else if(allowed[key]?.includes(value))properties[key]=value;
          }
          if(properties['Application method']==='Not specified')delete properties['Application method'];
          if(properties['Roll label notes']||['Machine or dispenser','Please help confirm'].includes(properties['Application method']))properties['Roll setup review']='Confirm requested roll settings and machine compatibility before production';
          else delete properties['Roll setup review'];
          if(artwork){
            Object.assign(properties,artwork);
            if(!artwork['_Artwork shape GCS object'])delete properties['_Artwork shape GCS object'];
            delete properties['Artwork shape preview'];delete properties['_Roll artwork required'];
            if(properties['Artwork status']==='Upload required in cart')delete properties['Artwork status'];
          }
          properties['_Roll notes saved']='yes';
          const sections=(helper?.getSectionsToRender?.()||[]).map(section=>section.id).slice(0,5);
          const result=await this.request(root+'/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:item.key,quantity:item.quantity,properties,...(sections.length?{sections,sections_url:window.location.pathname}:{})})});
          const updated=result.items?.find(line=>String(line.variant_id)===String(item.variant_id)&&Object.keys(properties).every(key=>line.properties?.[key]===properties[key]));
          if(!updated)throw new Error(this.dataset.failed);
          states.delete(s.key);s.key=updated.key;states.set(s.key,s);
          s.saved=!!(updated.properties['Artwork ID']&&updated.properties['_Artwork GCS object']);s.fileName=updated.properties['Artwork file']||'';
          if(artwork&&s.artwork?.['_Artwork version']===artwork['_Artwork version'])s.artwork=null;
          s.dirty=false;s.fields={};
          s.panels.forEach(panel=>{panel.dataset.lineKey=s.key;panel.fields.forEach(field=>{field.value=updated.properties[field.dataset.rollField]||'';});});
          this.notify(artwork?this.dataset.artworkSavedMessage:this.dataset.saved);
          completed=true;
          if(sections.length&&result.sections&&Object.values(result.sections).every(html=>typeof html==='string'))helper.reRenderSections(result.sections);
        }finally{window.updatingCart=false;}
      }).catch(error=>{this.notify(error.message||this.dataset.failed,true);throw error;}).finally(()=>{s.pending=null;this.notify();if(completed&&s.artwork)this.save().catch(()=>{});});
      queue=s.pending;this.notify(this.dataset.saving);return s.pending;
    }
    readyForCheckout(){return this.state.saved&&!this.state.uploading&&!this.state.editing&&!this.state.artwork;}
    requireArtwork(){
      this.message(this.dataset.artworkRequiredMessage,true);
      if(this.dataset.surface==='drawer'){window.location.assign(this.dataset.cartRoot||'/cart');return;}
      const host=this.querySelector('[data-roll-upload-host]');if(host)host.hidden=false;
      this.scrollIntoView({behavior:'smooth',block:'center'});this.querySelector('[data-upload-input]')?.focus();
    }
  }
  customElements.define('ink-roll-cart-notes',RollCartNotes);
  const flush=async event=>{
    if(resuming)return;
    const button=event.type==='submit'?event.submitter:event.target.closest?.(checkoutSelector);
    if(!button?.matches(checkoutSelector))return;
    const panels=[...document.querySelectorAll('ink-roll-cart-notes')];
    if(!panels.length)return;
    const unique=[...new Map(panels.map(p=>[p.state,p])).values()];
    if(unique.every(p=>p.readyForCheckout()&&!p.state.dirty&&!p.state.pending))return;
    event.preventDefault();event.stopImmediatePropagation();
    if(checkoutPending)return;checkoutPending=true;
    try{
      for(const panel of unique){
        if(panel.state.uploading||panel.state.editing){panel.requireArtwork();return;}
        await panel.save();
        if(!panel.readyForCheckout()){panel.requireArtwork();return;}
      }
      const formId=button.getAttribute('form');
      const current=button.isConnected?button:formId?document.querySelector('[name="checkout"][form="'+CSS.escape(formId)+'"]'):document.getElementById(button.id);
      if(current){resuming=true;current.click();setTimeout(()=>{resuming=false;},0);}
    }catch{unique.find(p=>p.state.dirty||p.state.artwork)?.scrollIntoView({behavior:'smooth',block:'center'});}
    finally{checkoutPending=false;}
  };
  document.addEventListener('click',flush,true);document.addEventListener('submit',flush,true);
})();
  } catch(e) { console.error(e); }
})();

})();
